import { TabType } from "@/store/deduction/drawer";
import { Tab } from "@ir/ui";
import { memo } from "react";

const DeductionInformationTab = () => {

    return (
        <Tab id={TabType.INFORMATION} aria-label={TabType.INFORMATION} title={TabType.INFORMATION}>
            {TabType.INFORMATION}
        </Tab>
    )
}

DeductionInformationTab.displayName = "DeductionInformationTab";

export default memo(DeductionInformationTab);